export default __webpack_public_path__ + "static/media/pubmatic.c5be60c2.svg";